import client from "./APIClient"

export default class TraindexApi {
  static getPatentText = args => {
    return client(
      "get-patent-text",
      { method: "POST", body: args }
    )
  }

  static rerankPatents = payload => {
    return client(
      "rerank-patents",
      { method: "POST", body: payload }
    )
  }

  static getFilteredData = payload => {
    return client(
      "get-filtered-data",
      { method: "POST", body: payload }
    )
  }

  static handleFeedback = payload => {
    return client(
      "feedback",
      { method: "POST", body: payload }
    )
  }

  static getTraindexData = payload => {
    return client(
      "get-traindex-data",
      { method: "POST", body: payload }
    )
  }
}
